import styled from 'styled-components'
import { H2, H3, H5, P } from '../../../shared_components/Library/Typeography'
import { Box } from '../../../shared_components/UI/Box'
import { BarryUIColorKey } from '../../../theme'
import DotsHorizontal from '../../../shared_components/Icons/DotsHorizontal'

export function Title({ children }) {
  return (
    <H2 s="XL" fw="semibold" c="text-primary">
      {children}
    </H2>
  )
}

export function Text({ children }) {
  return (
    <P s="L" fw="regular" c="text-primary">
      {children}
    </P>
  )
}

export function TokenAmount({ amount, label }) {
  return (
    <Box dc afe g={6} style={{ opacity: amount <= 0 ? 0.5 : 1 }}>
      <P s="S" fw="regular" c="text-brandPrimary">
        {label}
      </P>
      <Box ac g={4} fu aw>
        <img
          style={{ height: '20px' }}
          src="/zap-coin.svg"
          alt="zap coin icon"
        />
        <H5 s="M" fw="bolder" c="text-brandPrimary" uc ff="Proxima Nova">
          {amount.toLocaleString()}
        </H5>
      </Box>
    </Box>
  )
}

export function VaultsAmount({ amount }) {
  return (
    <Box ac g={8}>
      <img
        style={{ height: '38px' }}
        src="/vault-icon.svg"
        alt="zap vault icon"
      />
      <Box dc jc g={2}>
        <P s="L" fw="semibold" c="text-primary">
          {amount.toLocaleString()}
        </P>
        <P s="S" fw="regular" c="text-secondary">
          Vaults
        </P>
      </Box>
    </Box>
  )
}

export function GenericAmountBox({
  amount,
  description,
  highlightColor,
}: {
  amount: number | bigint
  description: string
  highlightColor?: BarryUIColorKey
}) {
  return (
    <StyledAmountBox dc g={6} pad={16}>
      <H3
        s="XL"
        fw="bolder"
        ff="Proxima Nova"
        c={highlightColor ?? 'text-primary'}
        uc
      >
        {amount.toLocaleString()}
      </H3>
      <P s="M" fw="regular" c="text-primary">
        {description}
      </P>
    </StyledAmountBox>
  )
}

const StyledAmountBox = styled(Box)`
  border-radius: var(--units-8, 8px);
  border: var(--units-1, 1px) solid var(--stroke-tertiary, #252525);
  background: var(--states-invert-alpha-16, rgba(0, 0, 0, 0.16));
`

export const ProgressBar = styled.div<{ w?: number; c?: string }>`
  width: 100%;
  height: 18px;
  border-radius: var(--units-88, 88px);
  background: var(--surface-minimal-alpha-secondary, rgba(255, 255, 255, 0.08));

  --dotSize: 0.5px;

  position: relative;

  ::after {
    /* Cover our element */
    content: '';
    position: absolute;
    inset: 0;
    width: ${({ w }) => w}%;
    max-width: 100%;
    height: 18px;

    /* Dotted background */
    background-image: radial-gradient(
      circle at center,
      black var(--dotSize),
      transparent 0
    );
    background-size: 3px 3px;
    background-repeat: round;
    background-position: 0 0, 0.65rem 0.65rem;
    background-color: ${({ c }) => c};
    border-radius: var(--units-88, 88px);

    z-index: 1;
  }

  > * {
    z-index: 2;
  }
`

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background: var(--stroke-tertiary, #252525);
`

export function DotsButton() {
  return (
    <StyledDots>
      <DotsHorizontal color="white" />
    </StyledDots>
  )
}

export const StyledDots = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  width: var(--units-24, 24px);
  height: var(--units-24, 24px);
  padding: 5.455px 5.454px 5.455px 5.455px;
  border-radius: 54.545px;
  background: var(--surface-minimal-alpha-secondary, rgba(255, 255, 255, 0.08));
`
